module.exports = __webpack_public_path__ + "img/profile.5761d64a.jpg";